import { render } from "./App.vue?vue&type=template&id=576d2e38&scoped=true"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=576d2e38&lang=less&scoped=true"

import exportComponent from "D:\\project\\famousBuild\\famous-build\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-576d2e38"]])

export default __exports__